import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from 'src/app/shared/shared.module';
import {IconsModule} from 'src/app/icons/icons.module';
import {SearchFilterComponent} from './search-filter.component';


@NgModule({
  declarations: [
    SearchFilterComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    IconsModule
  ],
  exports: [
    SearchFilterComponent
  ]
})
export class SearchFilterModule {
}
